import React, { Component } from "react";
import { Row, Col, Input, Divider, Button, Empty } from "antd";
import { AiOutlineSearch, AiOutlinePlus, FiPlusCircle } from "react-icons/all";
import { GrClose } from "react-icons/gr";
import "./style.css";
import EmployeCard from "../../components/EmployeCard";
import CustomModal from "../../components/modals/customModal";
import TextInput from "../../components/input/TextInput";
import { connect } from "react-redux";
import { UserAction } from "../../store/actions";
import { formatToNumber } from "../../config/utils";
import { EMAIL_REGX } from "../../config/variables";
import LoaderGif from "../../assets/images/ie_loader.gif";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
class EmployeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      editItem: false,
      edituserImage: "",
      filter: {
        order: "asc",
        page: 1,
        column: "email",
        search: "",
        per_page: 12,
        total_pages: 0,
        current_records: 0,
        total_pages: 0,
        status: "",
        current_page: 1,
      },
      payload: {
        title: "",
        first_name: "",
        last_name: "",
        phone: "",
        password: "",
        confirm_password: "",
        address: "",
        email: "",
        image: "",
      },
      errors: {
        first_nameError: "",
        last_nameError: "",
        phoneError: "",
        passwordError: "",
        confirm_passwordError: "",
        emailError: "",
      },
      isUpdate: false,
      userId: "",
      coverImageUrl: "",
    };
  }
  componentDidMount() {
    const { getUser } = this.props;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    getUser(companyId, this.state.filter);
  }
  componentDidUpdate(preProps, preState) {
    const { getUser } = this.props;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))[1]
      ?.rmx_company?.id;
    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          total_records: this.props?.metaData?.total_records,
          current_records: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filter.search !== this.state.filter.search ||
      preState.filter.column !== this.state.filter.column ||
      preState.filter.per_page !== this.state.filter.per_page ||
      preState.filter.page !== this.state.filter.page
    ) {
      getUser(companyId, this.state.filter);
    }
  }

  toggleModal = () => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
      isUpdate: false,
      payload: {
        title: "",
        first_name: "",
        last_name: "",
        phone: "",
        password: "",
        confirm_password: "",
        address: "",
        email: "",
        image: "",
      },
      errors: {
        first_nameError: "",
        last_nameError: "",
        phoneError: "",
        passwordError: "",
        confirm_passwordError: "",
        emailError: "",
      },
      edituserImage: "",
      image: "",
    });
  };
  onHandleChanged = (e) => {
    this.setState({
      payload: { ...this.state.payload, [e.target.name]: e.target.value },
      errors: { ...this.state.errors, [`${e.target.name}Error`]: "" },
    });
  };

  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  onSubmit = () => {
    let fNameError = "";
    let lNameError = "";
    let PNError = "";
    let CPError = "";
    let PError = "";
    let EError = "";
    const {
      payload: {
        first_name,
        last_name,
        phone,
        confirm_password,
        password,
        email,
      },
      isUpdate,
      userId,
    } = this.state;

    if (
      !first_name.trim().length ||
      !last_name.trim().length ||
      !phone.trim().length ||
      !EMAIL_REGX.test(email) ||
      (!password?.trim().length && !isUpdate) ||
      (password?.trim().length < 8 && !isUpdate) ||
      password !== confirm_password
    ) {
      if (!first_name.trim().length) {
        fNameError = "First Name is required";
        this.setState({
          errors: {
            ...this.state.errors,
            first_nameError: fNameError,
          },
        });
      }
      if (!last_name.trim().length) {
        lNameError = "Last Name is required";
        this.setState({
          errors: {
            ...this.state.errors,

            first_nameError: fNameError,

            last_nameError: lNameError,
          },
        });
      }
      if (!phone.trim().length || phone.length < 12) {
        PNError = "Phone number is required";
        this.setState({
          errors: {
            ...this.state.errors,
            first_nameError: fNameError,

            last_nameError: lNameError,
            phoneError: PNError,
          },
        });
      }
      if (!EMAIL_REGX.test(email)) {
        EError = "Email is required";
        this.setState({
          errors: {
            ...this.state.errors,
            first_nameError: fNameError,

            last_nameError: lNameError,
            emailError: EError,
            phoneError: PNError,
          },
        });
      }
      if (password.trim().length < 8) {
        PError = "Password should be at least 8 characters long";
        this.setState({
          errors: {
            ...this.state.errors,
            first_nameError: fNameError,
            last_nameError: lNameError,
            emailError: EError,
            passwordError: PError,
            phoneError: PNError,
          },
        });
      }

      if (!password.length && !confirm_password.length) {
        PError = "Password is required";
        CPError = "Confirm password is required";
        this.setState({
          errors: {
            ...this.state.errors,
            first_nameError: fNameError,

            last_nameError: lNameError,
            emailError: EError,
            passwordError: PError,
            confirm_passwordError: CPError,
            phoneError: PNError,
          },
        });
      }

      if (password !== confirm_password) {
        CPError = "password mismatch";

        this.setState({
          errors: {
            ...this.state.errors,
            first_nameError: fNameError,
            last_nameError: lNameError,
            emailError: EError,
            passwordError: PError,
            confirm_passwordError: CPError,
            phoneError: PNError,
          },
        });
      }

      return;
    }
    //
    !isUpdate &&
      this.props.createUser(
        this.state.payload,
        () => this.setState({ isOpenModal: false }),
        this.state.filter
      );
    isUpdate &&
      this.props.updateUser(
        this.state.payload,
        () => this.setState({ isOpenModal: false, isUpdate: false }),
        userId
      );
  };

  render() {
    // const Paddingstyle = {
    //   // Adding media querry..
    //   "@media (max-width: 400px)": {
    //     // padding: "100px",
    //     border: "1px solid red",
    //   },
    // };

    const {
      isOpenModal,
      filter: { per_page, column, page, order },
      payload: {
        first_name,
        last_name,
        address,
        phone,
        confirm_password,
        password,
        title,
        email,
      },
      errors: {
        first_nameError,
        last_nameError,
        passwordError,
        confirm_passwordError,
        emailError,
        phoneError,
      },
      isUpdate,
    } = this.state;
    var inputFileRef;
    const { users, isLoading, metaData } = this.props;
    console.log("IMAGE==>", users.length);
    return (
      <Row justify="center">
        <Col
          xl={24}
          lg={24}
          xs={24}
          sm={24}
          md={24}
          style={{
            minHeight: "calc(100vh - 4.8em)",
            width: "100%",
            padding: "2rem",
            background: "white",
            width: "100%",
            marginTop: "40px",
          }}
        >
          <Row justify="space-between" style={{ borderBottom: "solid 1px" }}>
            <Col xl={24} lg={24} xs={24} sm={24} md={24}>
              <Row justify="space-between">
                <Col xl={12} lg={12} xs={24} sm={24} md={12}>
                  <h5 className="text-left"> All Employees</h5>
                </Col>
                <Col>
                  <AiOutlineSearch
                    size="20"
                    onClick={() =>
                      this.setState({ isClose: !this.state.isClose })
                    }
                    className="pointer-cursor"
                  />

                  <Input
                    placeholder="Search..."
                    style={{
                      width: this.state.isClose ? "130px" : "0px",
                      padding: 5,
                      // marginTop: '10px',
                      background: "transparent",
                      border: "none",
                      borderBottom: "none",
                      marginRight: "5px",
                    }}
                    onChange={(e) =>
                      this.setState({
                        filter: {
                          ...this.state.filter,
                          search: e.target.value,
                        },
                      })
                    }
                  />
                  {this.state.isClose ? (
                    <GrClose
                      size="20"
                      onClick={() =>
                        this.setState({ isClose: !this.state.isClose })
                      }
                      style={{ marginRight: "20px" }}
                      className="pointer-cursor"
                    />
                  ) : null}

                  <span onClick={this.toggleModal} className="pointer-cursor">
                    <AiOutlinePlus size="20" />
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row style={{ marginTop: "3rem" }} justify="space-between">
            <Col xl={7} lg={6} md={14} sm={24} xs={24}>
              <Row justify="space-between">
                <Col xl={12} sm={12} md={14} lg={12}>
                  <label>Sort By</label>
                  <select
                    className="pointer-cursor"
                    style={{ padding: "5px 10px 5px 10px", marginLeft: "5px" }}
                    onChange={(e) => {
                      this.setState({
                        filter: {
                          ...this.state.filter,
                          column: e.target.value,
                        },
                      });
                    }}
                    value={column}
                  >
                    <option value="email">Email</option>
                    <option value="first_name">Name</option>
                  </select>
                </Col>
                <Col xl={12} sm={12} md={10}>
                  <label>Showing</label>
                  <select
                    className="pointer-cursor"
                    style={{
                      padding: "5px 10px 5px 10px",
                      marginLeft: "5px",
                      width: "73px",
                    }}
                    onChange={(e) => {
                      this.setState({
                        filter: {
                          ...this.state.filter,
                          per_page: e.target.value,
                        },
                      });
                    }}
                    value={per_page}
                  >
                    <option>12</option>
                    <option>24</option>
                    <option>48</option>
                    <option>96</option>
                  </select>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="start">
            {!isLoading ? (
              <>
                {users.map((item) => (
                  <Col xl={6} md={12} sm={24} xs={24} lg={8}>
                    <EmployeCard
                      item={item.user}
                      isUpdate={isUpdate}
                      onEdit={() => {
                        this.setState({
                          isOpenModal: true,
                          payload: item.user,
                          isUpdate: true,
                          userId: item.id,
                          editItem: true,
                          edituserImage: item?.user?.image?.original,
                        });
                      }}
                      updateUser={this.props.updateUser}
                      status={item.status === 2 ? "active" : "deactivate"}
                      userId={item.id}
                    />
                  </Col>
                ))}
                {!users.length && (
                  <Col span={23}>
                    <Empty description="Nothing to show right now" />
                  </Col>
                )}
              </>
            ) : (
              <>
                {isLoading && (
                  <img src={LoaderGif} height={"60"} width={"60"} />
                )}
              </>
            )}
            {!!users.length && (
              <Col xs={24} sm={24} md={23} lg={24} xl={24}>
                <Row
                  gutter={[5, 0]}
                  xs={24}
                  sm={24}
                  md={23}
                  lg={23}
                  xl={23}
                  justify="end"
                >
                  <Col className="tablePagination">
                    {`Displaying ${metaData?.current_records} of ${metaData?.total_records}`}
                    <Button
                      type="link"
                      icon={<BsChevronLeft color="#686868" size={15} />}
                      onClick={this.previousPage}
                      disabled={this.state.filter.page === 1}
                    />
                    <Button
                      type="link"
                      icon={<BsChevronRight color="#686868" size={15} />}
                      onClick={this.currentPage}
                      disabled={
                        this.state.filter.total_pages === this.state.filter.page
                      }
                    />
                  </Col>
                </Row>
              </Col>
            )}
            <CustomModal
              // bodyStyle={{ overflowY: "scroll" }}
              visible={isOpenModal}
              onCancelModal={this.toggleModal}
              footer={[
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={this.onSubmit}
                >
                  Save
                </Button>,
              ]}
            >
              <Col xl={24}>
                {this.state.editItem === true ? (
                  <h5 className="text-center st-primary">Edit Member</h5>
                ) : (
                  <h5 className="text-center st-primary">Add Member</h5>
                )}
                <Divider />
              </Col>
              <Col xl={24} className="pointer-cursor">
                <Row justify="center">
                  <Col
                    xl={6}
                    onClick={() => {
                      inputFileRef.click();
                      this.setState({
                        image: "",
                      });
                    }}
                  >
                    {this.state.edituserImage ? (
                      <img
                        src={this.state.edituserImage}
                        width="120"
                        height="100"
                        style={{ objectFit: "contain" }}
                      />
                    ) : (
                      <FiPlusCircle
                        size="90"
                        color="#009688"
                        className="text-center pointer-cursor"
                      />
                    )}

                    {this.state.editItem === true ? (
                      <span>CHANGE IMAGE</span>
                    ) : (
                      <span></span>
                    )}
                  </Col>
                  <Col xl={24}>
                    <form>
                      <Row justify="space-between" gutter={[5, 30]}>
                        <Col xl={24}>
                          <TextInput
                            label="Title"
                            name="title"
                            onChange={this.onHandleChanged}
                            value={title}
                          />
                        </Col>
                        <Col xl={10}>
                          <TextInput
                            label="First Name"
                            name="first_name"
                            required
                            onChange={this.onHandleChanged}
                            value={first_name}
                            isError={first_nameError}
                          />
                          <span className="danger-color">
                            {first_nameError && first_nameError}
                          </span>
                        </Col>
                        <Col xl={10}>
                          <TextInput
                            label="Last Name"
                            name="last_name"
                            required
                            onChange={this.onHandleChanged}
                            value={last_name}
                          />
                          <span className="danger-color">
                            {last_nameError && last_nameError}
                          </span>
                        </Col>
                        <Col xl={10}>
                          <TextInput
                            label="Phone Number"
                            name="phone"
                            required
                            type="text"
                            onChange={this.onHandleChanged}
                            // isError={}

                            value={formatToNumber(phone || "")}
                          />
                          <span className="danger-color">
                            {phoneError && phoneError}
                          </span>
                        </Col>
                        <Col xl={10}>
                          <TextInput
                            label="Email Address"
                            required
                            name="email"
                            onChange={this.onHandleChanged}
                            value={email}
                          />
                          <span className="danger-color">
                            {emailError && emailError}
                          </span>
                        </Col>
                        {!isUpdate && (
                          <>
                            <Col xl={10}>
                              <TextInput
                                name="password"
                                label="Password"
                                required
                                onChange={this.onHandleChanged}
                                type="password"
                                value={password}
                              />
                              <span className="danger-color">
                                {passwordError && passwordError}
                              </span>
                            </Col>
                            <Col xl={10}>
                              <TextInput
                                label="Confirm Password"
                                name="confirm_password"
                                required
                                type="password"
                                value={confirm_password}
                                onChange={this.onHandleChanged}
                              />
                              <span className="danger-color">
                                {confirm_passwordError && confirm_passwordError}
                              </span>
                            </Col>
                          </>
                        )}

                        <Col xl={24}>
                          <TextInput
                            name="address"
                            label="Address"
                            onChange={this.onHandleChanged}
                            value={address}
                          />
                        </Col>
                      </Row>
                      <input
                        type="file"
                        id="avatar"
                        name="avatar"
                        accept="image/png, image/jpeg"
                        className="d-none"
                        ref={(ref) => (inputFileRef = ref)}
                        onChange={(e) => {
                          let reader = new FileReader();
                          let file = e.target.files[0];
                          reader.readAsDataURL(file);

                          reader.onloadend = () => {
                            console.log("reader==>", reader.result);
                            this.setState({
                              // payload: {
                              //   ...this.state.payload,
                              //   image: e.target.files[0],
                              // },
                              edituserImage: reader.result,
                              payload: {
                                ...this.state.payload,
                                image: e.target.files[0],
                              },
                            });
                          };
                        }}
                      />
                    </form>
                  </Col>
                </Row>
              </Col>
            </CustomModal>
          </Row>
        </Col>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    users: store.UserReducer.users,
    isLoading: store.UserReducer.isLoading,
    metaData: store.UserReducer.metaData,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getUser: (id, params) => dispatch(UserAction.getUserReq(id, params)),
    createUser: (payload, cb, params) =>
      dispatch(UserAction.createUserReq(payload, cb, params)),
    updateUser: (body, cb, id, active) =>
      dispatch(UserAction.updateProfileInfoReq(body, cb, id, active)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeContainer);
